import React, { useState } from 'react';
import styled from 'styled-components';
import { Flex, Box, Button } from 'rebass';
import { Label, Input, Select, Textarea } from '@rebass/forms';
import { FiUserPlus, FiPlus, FiUploadCloud, FiUsers, FiLayers, FiXCircle } from 'react-icons/fi';
import NiceDropdown from 'components/NiceDropdown';
import ReactModalActions from 'components/ReactModalActions';
import ListWrapper from 'components/ListWrapper';
import ItemWrapper from 'components/ItemWrapper';
import TooltipIcon from 'components/TooltipIcon';
import ReactTooltip from 'react-tooltip';
import cloneDeep from 'lodash/cloneDeep';
import helpers from 'utils/helpers';

function CustomAttributeEdit(props) {
    
    //const [isNew, setIsNew] = useState(props.isNew)
    const [cspa, setCspa] = useState(props.cspa);

    function onFormChange(e) {
        const { name, value } = e.target;
        setCspa(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    function updateDefinition(e, d, field_name) {
        let { definition } = cloneDeep(cspa);
        const index = definition.findIndex(def_loc => def_loc && def_loc.id == d.id);
        if (index > -1) {
            definition[index][field_name] = e.target.value;
            setCspa(prevState => ({
                ...prevState,
                definition: definition
            }));
        }
    }

    function addDefinitionItem(label, value) {

        let { definition } = cloneDeep(cspa);
        if (!Array.isArray(definition)) {
            definition = [];
        }

        definition.push({
            id: helpers.ID(),
            label: label,
            value: value,
            creating: 1
        });

        setCspa(prevState => ({
            ...prevState,
            definition: definition
        }));
    }

    return (
        <Flex sx={{flexDirection: 'column'}}>
            <form onSubmit={ e => {
                    e.preventDefault();
                    props.onSave(cspa);
                    props.onClose();
                }}>
                <Box mx={4} mb={4} mt={3}>
                    <Label>Title</Label>
                    <Input type='text' name='title' value={cspa.title} onChange={onFormChange} autoFocus required />
                    <Label mt={3}>Type</Label>
                    <Select name='type' value={cspa.type} onChange={onFormChange}>
                        <option value='text'>Text</option>
                        <option value='dropdown'>Single-select (Dropdown)</option>
                        <option value='checkbox'>Multi-select (Checkbox)</option>
                    </Select>

                    { (cspa.type == 'dropdown' || cspa.type == 'checkbox') && 
                        <>
                            <Label mt={3}>Options</Label>
                            <ListWrapper
                                style={{
                                    position: 'relative',
                                    border: '1px solid #eee',
                                    borderRadius: '4px'
                                }}
                            >
                                <ItemWrapper className='header-row-dark' style={{padding: '8px 16px', minHeight: '32px'}}>
                                    <Box width={1 / 2}>
                                        Label
                                        <TooltipIcon for={`tooltip-label`} margin="0px 0 0 4px" />
                                    </Box>
                                    <Box width={1 / 2}>
                                        Value
                                        <TooltipIcon for={`tooltip-value`} margin="0px 0 0 4px" />
                                    </Box>
                                </ItemWrapper>
                                { cspa.definition && cspa.definition.map(d => {
                                    
                                    if (!d) { return; }

                                    return <ItemWrapper style={{ color: 'black' }}>
                                        <Box width={1/2} style={{paddingRight: '16px'}}>
                                            <Input value={d.label} onChange={(e) => {
                                                updateDefinition(e, d, 'label');
                                            }} required />
                                        </Box>
                                        <Box width={1/2}>
                                            <Flex>
                                                <Input value={d.value} mr={3}
                                                    onChange={(e) => {
                                                        updateDefinition(e, d, 'value');
                                                    }}
                                                    required
                                                />
                                                <Button type='button' variant='transparent' onClick={() => {
                                                    let { definition } = cloneDeep(cspa);
                                                    const index = definition.findIndex(def_loc => def_loc && def_loc.id == d.id);
                                                    
                                                    if (index > -1) {
                                                        definition.splice(index, 1);
                                                        setCspa(prevState => ({
                                                            ...prevState,
                                                            definition: definition
                                                        }));
                                                    }
                                                }}><FiXCircle /></Button>
                                            </Flex>
                                        </Box>
                                    </ItemWrapper>
                                })}
                                <ItemWrapper style={{ border: 0, flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <Button type='button' variant='tertiary' onClick={e => { addDefinitionItem('', ''); }}><FiPlus/> Add an option</Button>
                                </ItemWrapper>
                            </ListWrapper>
                        </>
                    }
                </Box>
                <ReactModalActions>
                    <div style={{ textAlign: 'right', width: '100%' }}>
                        <Button
                            type="button"
                            variant="tertiary"
                            mr={3}
                            onClick={() => {
                                props.onClose();
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            type="submit"
                            sx={{ marginRight: 0 }}
                        >
                            Save
                        </Button>
                    </div>
                </ReactModalActions>
            </form>
        </Flex>);
}

export default CustomAttributeEdit;